import { hasProp } from "../../../helpers/Class";
import CarrierDestination from "./CarrierDestination";
import Carrier from "./Carrier";
import i18n from "@/i18n";

class CarrierArea {
    constructor(area = null) {
        this.id = !hasProp(area, "id") ? undefined : area.id;
        this.carrierId = !hasProp(area, "carrierId") ? undefined : area.carrierId;
        this.carrier = !hasProp(area, "carrier") ? new Carrier() : new Carrier(area.carrier);
        this.name = !hasProp(area, "name") ? undefined : area.name;
        this.enabledForApi = !hasProp(area, "enabledForApi") ? true : area.enabledForApi;
        this.margin = !hasProp(area, "margin") ? null : area.margin;

        this.destinations = [];
        if (area !== null && area.destinations) {
            this.destinations = area.destinations.map(destination => new CarrierDestination(destination));
        }
    }

    sanitizeForAPI() {
        if (this.margin !== undefined && typeof this.margin !== "number" &&
            (this.margin === null || this.margin.trim() === "")) {
            this.margin = null;
        }
    }

    marginLabel() {
        if (this.margin === null) {
            return i18n.t("CarrierAreaClass.notDefined");
        }
        return `${this.margin} %`;
    }
}

export default CarrierArea;